{
  "common": {
    "id": "ID",
    "more": "More",
    "more_items": "+{{items}} more",
    "showAvatars": "Members",
    "done": "Done",
    "restore": "Restore",
    "delete": "Delete",
    "edit": "Edit",
    "deadline": "Deadline",
    "deadline_change": "Change deadline",
    "dev_assign": "Assign developer",
    "archive": "Archive",
    "import": "Import",
    "remove": "Remove",
    "total": "Total",
    "subtotal": "Subtotal",
    "accept": "Accept",
    "cancel": "Cancel",
    "close": "Close",
    "accept_full": "Yes, accept",
    "cancel_full": "No, cancel",
    "continue_full": "Yes, continue",
    "yes": "Yes",
    "no": "No",
    "save": "Save",
    "save_changes": "Save changes",
    "from": "from",
    "send": "Send",
    "to": "to",
    "at": "at",
    "of": "of",
    "you": "You",
    "said": "said",
    "back": "Back",
    "open": "Open",
    "copy": "Copy",
    "choose": "Choose",
    "confirm": "Confirm",
    "show": "Show",
    "apply": "Apply",
    "clear": "Clear",
    "add": "Add",
    "new": "New",
    "add_new": "Add new",
    "desc": "Description",
    "title": "Title",
    "label": "Label",
    "prev_page": "Previous page",
    "prev": "Previous",
    "next_page": "Next page",
    "next": "Next",
    "clear_filters": "Clear filters",
    "delete_project_question": "Are you sure you want to delete this project?",
    "delete_template_question": "Are you sure you want to delete \"{{template}}\" template?",
    "delete_accept": "Yes, delete",
    "confirm_deletion": "Please type project name to confirm.",
    "board": "Board",
    "no_limit": "Unlimited",
    "user": "user",
    "users": "users",
    "user_s": "user(s)",
    "project": "Project",
    "projects": "Projects",
    "project_s": "project(s)",
    "workspace": "Workspace",
    "estimate": "estimate",
    "estimates": "estimates",
    "for": "For",
    "per": "per",
    "and": "and",
    "email_placeholder": "eg. name@client.com",
    "created_on": "Created on",
    "created": "Created",
    "not_again": "Don't show again",
    "attachments_add": "Add attachment",
    "min": "Min",
    "avg": "Avg",
    "max": "Max",
    "enable": "Enable",
    "disable": "Disable",
    "duplicate": "Duplicate",
    "unnamed": "Unnamed",
    "unnamed_element": "Unnamed element",
    "see_more": "see more",
    "see_less": "see less",
    "restore_value": "Restore auto-calculated value",
    "na": "n/a",
    "click_here": "click here",
    "warning": "Warning!",
    "danger": "Alert!",
    "custom": "custom",
    "auto": "auto",
    "cancel_remove": "No, keep it",
    "confirm_remove": "Yes, remove",
    "refresh": "Refresh",
    "export": "Export",
    "hide": "Hide",
    "default": "Default",
    "default_set": "Set as default",
    "default_unset": "Unset default",
    "percentage": "Percentage",
    "work_type": "Work type",
    "work_types": "Work types",
    "show_more": "Show more",
    "show_less": "Show less",
    "base_value": "Base value",
    "version": "Version",
    "color": "Color",
    "sample": "Sample",
    "template": "Template",
    "no_options": "No options",
    "lang_detect": "Detect language",
    "drag_rearrange": "Drag to rearrange",
    "eg": "e.g.",
    "etc": "etc.",
    "undo": "Undo",
    "redo": "Redo",
    "include": "Include",
    "exclude": "Exclude",
    "none": "None",
    "ok": "Ok",
    "apply_to": "Apply to",
    "all_sections": "All sections",
    "all_sections_apply": "Apply to all sections",
    "remember_session_choice": "Remember my choice for this session",
    "advanced_settings": "Advanced settings"
  },
  "time": {
    "hour": "hour",
    "day": "day",
    "week": "week",
    "month": "month",
    "year": "year"
  },
  "timely": {
    "hour": "hourly",
    "day": "daily"
  },
  "times": {
    "h": "h",
    "hour": "hours",
    "day": "days",
    "week": "weeks",
    "month": "months",
    "year": "years"
  },
  "formats": {
    "single": "Single value",
    "min_max": "Min - max"
  },
  "rounding": {
    "0": "None (fixed decimals)",
    "1": "Round down",
    "2": "Round up",
    "3": "Round"
  },
  "description_mode": {
    "1": "Displayed as tooltip",
    "2": "Displayed as separate row",
    "3": "Displayed in new column"
  },
  "cell_mode": {
    "avg": "Single",
    "var": "Min-max"
  },
  "buffer_mode": {
    "1": "Popover",
    "2": "Min-max"
  },
  "color_picker_types": {
    "font": "font",
    "border": "border",
    "background": "background"
  },
  "sorting": {
    "updated_asc": "Last modified (A-Z)",
    "updated_desc": "Last modified (Z-A)",
    "created_asc": "Creation date (A-Z)",
    "created_desc": "Creation date (Z-A)",
    "name_asc": "Alphabetically (A-Z)",
    "name_desc": "Alphabetically (Z-A)"
  },
  "project_types": {
    "free": "Free",
    "trial": "Trial",
    "mini": "PDF",
    "standard": "Standard",
    "premium": "Premium",
    "enterprise": "Enterprise"
  },
  "role_descriptions": {
    "technical": "Developer, QA engineer, designer and any other type of technical employee at your software development agency. He can create, edit and estimate the projects, but he doesn’t see the pricing and hourly rates - he only sees and operates with workload estimates in {{times}}. He also can’t share the proposal with the client and can’t access the customer’s browser sessions recordings.",
    "business": "Sales or marketing professional at your company, as well as project manager. They can do the same actions as developer, but they can also see the pricing, hourly rates, share the proposals with the clients and watch their browser session recordings."
  },
  "roles": {
    "author": "Project's author",
    "owner": "Project's owner",
    "contractor": "Project's contractor"
  },
  "plans": {
    "package_free": "Free",
    "package_starter": "Starter",
    "package_business": "Business",
    "package_pro": "Pro",
    "package_trial": "Trial",
    "package_mini": "Mini",
    "custom": "Custom",
    "default": "Current plan"
  },
  "billing": {
    "forever": "Forever",
    "per_month": "Monthly",
    "per_month_fancy": "Billed monthly",
    "per_year": "Annually",
    "per_year_fancy": "Billed annually"
  },
  "dashboard_mode": {
    "active": "Active Projects",
    "company": "Company Projects",
    "shared": "Shared Projects"
  },
  "feature_alerts": {
    "base": "Upgrade your plan to",
    "base_named": "Upgrade to {{plan}} plan to",

    "user": "invite more users",
    "estimation": "have more active projects",
    "allocation": "allocate team members",
    "timeline": "access project timeline",
    "pdf": "add PDF presentation",
    "recordings": "view recordings",
    "visibility": "manage quote visibility",
    "profitability": "manage quote profitability",
    "internal_comments": "see and add internal comments",
    "comments": "access client comments",
    "domain": "use your domain",
    "jira": "integrate with Jira",
    "comparison": "access budget tracking",
    "ai_story": "generate user story with AI",
    "ai_desc": "generate description with AI",
    "ai_element": "generate project elements with AI",
    "ai_project": "generate projects with AI",
    "buffers": "manage quote buffers",
    "custom_buffers": "add custom quote buffers",
    "boards": "create additional boards",
    "text_description": "add description to the quote",
    "labels": "add and edit labels"
  },
  "features": {
    "user": "",
    "library": "Library",
    "templates": "Templates",
    "table": "Estimation table & versioning",
    "import": "Estimations import from Excel",
    "allocation": "Team allocation",
    "timeline": "Project Timeline",
    "sharing": "Estimate sharing with client",
    "branding": "Your own branding",
    "pdf": "Merging estimate with PDF presentations",
    "recordings": "Recordings of customer sessions",
    "visibility": "Visibility management for the client",
    "profitability": "Project profitability management",
    "internal_comments": "Internal comments in projects",
    "comments": "Comments",
    "domain": "Your own domain",
    "jira": "Jira integration",
    "comparison": "Estimation vs. Reality comparison",
    "success_man": "1h /per month with Estimation Success Manager",
    "sales_man": "1h of software projects sales consultation per month with Sales Success Manager",
    "ai_story": "AI generation of user stories.",
    "ai_desc": "NAME: AI GEN. USER DESC",
    "ai_element": "NAME: AI GEN. USER ELEMENTS",
    "ai_project": "AI powered estimate generation",
    "buffers": "Buffers in your estimates",
    "custom_buffers": "Custom buffers in your estimates",
    "boards": "Team boards",
    "text_description": "Description in your quotes",
    "labels": "Labels in project elements"
  },
  "feature_desc": {
    "library": "Create & save repeatable quoting components in library and add them to new quotes with a single click.",
    "templates": "Create typical quoting templates in your company.",
    "table": "Use our super easy estimation table with all its features to speed up your estimates.",
    "import": "Import your old quotes from Excel and use them as templates",
    "allocation": "Allocate different team compositions to your projects and pick the most optimal one for delivery time & cost.",
    "timeline": "Automatically generate a clear project timeline showing the team composition and billing for every month.",
    "sharing": "Share the quote with your client via link or email.",
    "branding": "Easily apply your branding and save it as preset for future proposals.",
    "pdf": "Merge the created quote with your company deck and share as a full proposal through single link.",
    "recordings": "See how your customers interacted with your proposal.",
    "visibility": "Decide which parts of your quote are visible to your customer and which are hidden.",
    "comments": "Work with your customers on the quote through the comments.",
    "domain": "Share the quotes & proposals from your own domain, e.g. offers.companyname.com.",
    "jira": "Create a full project backlog in Jira with 3-clicks import of quotes from Apropo.",
    "comparison": "Get a clear and fully automated budget tracking thanks to real-time automated comparison of quoted and spent time.",
    "success_man": "Get 1 hour of consultation every month with Quoting Optimization Consultant to maximize the conversion rate of your quotes.",
    "sales_man": "Get 1 hour of consultation every month with experienced IT Sales Success Manager to learn about techniques that will help you sell more.",
    "ai_story": "Let AI generate the entire user story for the feature of your quote with just one click.",
    "ai_desc": "DESCRIPTION: AI GEN. USER DESC",
    "ai_element": "DESCRIPTION: AI GEN. USER ELEMENTS",
    "boards": "DESCRIPTION: BOARDS",
    "labels": "Create & add labels to rows (e.g. Must-have, Could-have, etc.) and create price variants based on them in just 2 clicks.\n\nThis will help you engineer your pricing and negotiate with your clients even more effectively!"
  },
  "notifications": {
    "moved": "moved",
    "added": "added",
    "archived": "archived",
    "older": "See older ones",
    "none": "You have no unread messages yet. You’ll be notified right after something pops up!"
  },
  "complexities": {
    "mvp": {
      "title": "MVP",
      "desc": "Most essential functionalities to satisfy early customers",
      "full_desc": "The MVP contains the most essential functionalities to satisfy early customers and gather feedback for future development. Anything beyond major functionality is not included."
    },
    "mlp": {
      "title": "Standard",
      "desc": "Most common functionalities",
      "full_desc": "The Standard version contains the most common functionalities used in similar applications. Those functionalities are expected from the user perspective."
    },
    "mmp": {
      "title": "Full-scope",
      "desc": "All functionality + advanced features",
      "full_desc": "The Full version contains all functionality covered in the Standard template and additionally advanced features that used the latest technologies."
    }
  },
  "payments": {
    "subscription": {
      "title": "Subscribe to \"{{name}}\" plan",
      "payment_info": "You will be billed ${{price}}. Your subscription will automatically renew on {{date}} when you'll be charged {{price}}$. You can cancel it at any time.",
      "payment_info_trial": "Your subscription will automatically renew on {{date}} when you'll be charged {{price}}$. You can cancel it at any time.",
      "update": "Change subscription to \"{{name}}\"",
      "update_lower": "Your current subscription will be valid to {{date}}, after which it will renew with all of the changes and you will be charged {{price}}$.",
      "update_higher": "You will gain all benefits of \"{{name}}\" plan. Your subscription will automatically renew on {{date}} when you will be charged {{price}}$. You can cancel it at any time.",
      "cancel": "Are you sure you want to cancel your subscription?",
      "cancel_info": "Your current subscription will be valid to {{date}}, after which your account will switch to \"Free\" plan.",
      "cancel_confirm": "Please enter your password to confirm your cancellation.",
      "upgrade_error": "Can't upgrade subscription",
      "upgrade_error_info": {
        "text": "Before switching to smaller subscription",
        "estimates": "archive or remove some of the projects",
        "users": "remove users"
      }
    },
    "template": {
      "title": "Purchase \"{{name}}\" template",
      "payment_info": "You will be billed ${{price}}. This is a one-time purchase."
    },
    "subscribe": "Subscribe",
    "method": "Payment method",
    "new_method": "New payment method",
    "method_select": "Select payment method"
  },
  "errors": {
    "network": "Something went wrong. Please try again later or contact us.",
    "try_again": "Something went wrong, try again!",
    "code": {
      "activate": "Enter code from your activation email",
      "generic": "Enter valid code"
    },
    "email": {
      "required": "Enter valid E-mail address",
      "invited": "User is already invited to the board",
      "max": "Email must have a maximum of 64 characters",
      "duplicate": "This email is already added",
      "work": "Please enter a valid work email"
    },
    "name": {
      "required": "Enter your name",
      "max": "Name must have a maximum of 64 characters"
    },
    "version_key": {
      "required": "Select version to import data from."
    },
    "terms": {
      "required": "Agree to our Terms & Conditions"
    },
    "policy": {
      "required": "Agree to our Privacy Policy"
    },
    "password": {
      "required": "Enter password",
      "min": "Password must have a minimum of 8 characters",
      "max": "Password must have a maximum of 128 characters",
      "pattern": "Password must include at least least one number, one special character, one uppercase and lowercase letter",
      "format": "Password provided is not valid",
      "not_valid": "Provided password is not valid",
      "current_not_valid": "Actual password provided is not valid",
      "match": "Passwords must match",
      "unique": "Must be different from old password"
    },
    "board": {
      "required": "Enter your board name",
      "max": "Board's name must have a maximum of 64 characters",
      "min": "Board's name must have a minimum of 4 characters"
    },
    "file": {
      "upload_error": "Maximum file size you can upload is {{mb}} MB.",
      "too_large": "Maximum file size you can upload is {{mb}} MB.",
      "too_many": "Maximum amount of files you can upload is {{amount}}",
      "wrong_format": {
        "single": "File type must be {{type}}.",
        "multiple": "File type must be one of: {{type}}."
      }
    },
    "dropzone": {
      "file-invalid-type": "File type is invalid",
      "file-too-large": "File type is too large",
      "file-too-small": "File type is too small",
      "too-many-files": "Too many files"
    },
    "editor": {
      "project": {
        "title": "We could not open your project.",
        "full": "Something went wrong with loading your project. Please contact tech support."
      },
      "project_deleted": {
        "title": "This project was removed by another user."
      },
      "project_unknown": {
        "title": "We could not open your project."
      },
      "template": {
        "title": "We could not open your template.",
        "full": "Something went wrong with loading your template. Please contact tech support."
      },
      "template_deleted": {
        "title": "This template was removed by another user."
      },
      "template_unknown": {
        "title": "We could not open your template."
      }
    },
    "company": {
      "name": {
        "required": "Enter your company name",
        "max": "Company name must have a maximum of 64 characters"
      },
      "country": "Enter country",
      "nip": {
        "required": "Enter VAT number",
        "regex": "Enter valid VAT number"
      },
      "city": "Enter country"
    },
    "font": {
      "name": {
        "required": "Enter font name",
        "max": "Font name must have a maximum of 64 characters",
        "duplicate": "Font with such name already exists"
      },
      "file": {
        "required": "Upload font file"
      }
    },
    "no_subscription": {
      "title": "No subscription",
      "admin": "Your trial period has ended. Select your subscription plan and fill payment details to unlock your account.",
      "user": "The trial period for your company has ended. Contact your company account owner for more details.",
      "action": "Click here to manage your subscription"
    },
    "project": {
      "name": {
        "required": "Enter project name",
        "min": "Project name must have at least 4 characters",
        "max": "Project name must have a maximum of 64 characters"
      },
      "workType": {
        "required": "Choose at least one work type"
      },
      "status": {
        "title": "Project can't be moved",
        "text": "You don't have permissions to move this project. Only admins and users assigned to the projects can reorder them or move them to different columns."
      },
      "ai_prompt": {
        "required": "Enter prompt for our AI or attach at least one file"
      }
    },
    "jira": {
      "issueType": {
        "required": "Select target issue type"
      }
    },
    "stripe": {
      "incomplete_cvc": "Your card's security code is incomplete.",
      "incomplete_expiry": "Your card's expiration date is incomplete.",
      "incomplete_number": "Your card number is incomplete.",
      "invalid_number": "Your card number is invalid.",
      "invalid_expiry_month_past": "Your card's expiration date has already passed",
      "card_declined": "Your card has been declined.",
      "invalid_vat": "Invalid VAT number for your country."
    },
    "msal": {
      "alert": {
        "title": "Oh no!",
        "content": "We couldn't confirm your identity using your Microsoft account."
      },
      "user_cancelled": "Login action cancelled!",
      "interaction_in_progress": "Login action already in progress!",
      "monitor_window_timeout": "Identity confirmation timeout"
    },
    "bt": {
      "unique_key": "Your project key must be unique",
      "unique_name": "Your project name must be unique",
      "issueType": {
        "required": "Choose at least one element"
      },
      "mappingSections": {
        "required": "Choose at least one section"
      },
      "api_key": {
        "scope": {
          "required": "Select scope for your API key"
        },
        "user": {
          "required": "Select user for your API key"
        }
      }
    },
    "api_key": {
      "scope": {
        "required": "Select scope for your API key"
      },
      "user": {
        "required": "Select user for your API key"
      }
    }
  },
  "forms": {
    "email": "Company E-mail",
    "currency": "Company currency",
    "name": "Full Name",
    "company_name": "Company name",
    "code": "Confirmation code from e-mail",
    "password": {
      "generic": "Password",
      "current": "Current Password",
      "new": "New password",
      "repeat": "Repeat password",
      "reset": "Reset your password"
    },
    "legal": {
      "read": "I have read and agree to the",
      "terms": "terms & conditions",
      "policy": "privacy policy"
    },
    "invoice_email": "Invoice email",
    "invoice_send": "Email invoices to",
    "try_product_1": "If you have any questions, do not hesitate to contact us",
    "try_product_here": "here",
    "try_product_2": "or by sending an email on",
    "upload_files": "Upload files",
    "no_attachments": "No attachments added.",
    "board_invite": {
      "title": "Invite team members",
      "invite_technical": "Invite Technical Users",
      "invite_business": "Invite Business Users",
      "invite_user": "Invite Users",
      "subtitle": "Type in the email addresses of your team members that you want to invite to your company board",
      "subtitle_chosen_board": "Add new members by sending them invitation links",
      "success": "Invitation link has been sent to the given emails. Let them know to check their inboxes! <br/><br /> PS. If they can’t find it in the main inbox, let them know to check the spam folder",
      "fail": "Invitation failed",
      "fail_domain": "We do not support generic email domains, such as gmail.com, outlook.com, etc. Please enter a valid business email.",
      "fail_desc": "These emails were skipped because their owners are already members of other organizations in Apropo. In order to invite them, please ask to delete their current accounts and try inviting again."
    },
    "feedback": {
      "title": "Submit your feedback",
      "content": "Contents"
    },
    "contact": {
      "title": "Contact us",
      "phone": "Phone number",
      "company": "Company",
      "message": "Message"
    },
    "company": {
      "name": "Company name",
      "city": "City",
      "postcode": "Post code",
      "street": "Street",
      "phone": "Phone number",
      "nip": "VAT Number",
      "logo": "Company logo",
      "country": "Country (required)"
    },
    "template": {
      "name": "Template name",
      "name_enter": "Enter new template name",
      "description": "Template description (optional)",
      "description_enter": "Provide template description",
      "types": "Project types",
      "category": "Template type",
      "category_enter": "Select template type",
      "types_enter": "Select project types",
      "comments_project": {
        "short": "This project includes comments.",
        "full": "This project includes comments. I want to save the comments in the template.",
        "yes": "I want to save them in the template"
      },
      "comments_template": {
        "short": "This template includes comments.",
        "full": "This template includes comments. I want to save the comments in the project.",
        "yes": "I want to save them in the project"
      }
    }
  },
  "proposal_parts": {
    "editor_sections": {
      "summary": "Summary",
      "timeline": "Project timeline",
      "timeline_beta": "Project timeline (beta)",
      "breakdown": "Estimate breakdown",
      "description": "Description"
    },
    "timeline_dropdowns": {
      "sections": "Sections",
      "team": "Team Allocation",
      "billing": "Billing"
    },
    "levels": {
      "1": "Sections + Modules",
      "2": "Sections + Modules + Features",
      "3": "Sections + Modules + Features + Tasks"
    },
    "levels_estimates": {
      "-1": "Don't show estimates at all",
      "0": "Sections only",
      "1": "Sections + Modules",
      "2": "Sections + Modules + Features",
      "3": "Sections + Modules + Features + Tasks"
    },
    "module_levels": {
      "level_-1": "project",
      "level_0": "section",
      "level_1": "module",
      "level_2": "feature",
      "level_3": "task"
    },
    "modules_levels": {
      "-1": "Summary",
      "0": "Sections",
      "1": "Modules",
      "2": "Features",
      "3": "Tasks"
    },
    "section_titles": {
      "section": "Sections",
      "module": "Modules",
      "feature": "Features",
      "task": "Tasks"
    },
    "row_types": {
      "workload": "Workload",
      "fixedPrice": "Fixed cost",
      "material": "Materials"
    },
    "section_types": {
      "workload": "Workload",
      "material": "Materials"
    },
    "price_modifiers": {
      "discount": "Discount",
      "overhead": "Overhead"
    },
    "price_modifier_modes": {
      "percent": "Percent",
      "fixedPrice": "Fixed amount"
    }
  },
  "alerts": {
    "mobile_experience": {
      "title": "Mobile experience",
      "text": "Due to the nature of use cases, our interface does not fully support mobile devices yet and using Apropo on mobile devices is not recommended.",
      "text2": "Please log in on your desktop device."
    },
    "no_subscription": {
      "title": "Hurry!",
      "trial_7": "<p>Your trial is ending in just 7 days! Book a call with us for a free product demo to see how Apropo can help your business reach its full potential.</p></br><p>Don't miss out on this opportunity to transform the way you work.</p>",
      "trial_3": "<p>Your trial is ending in just 3 days! Don't miss out on the opportunity to see how Apropo can revolutionize estimating process in your business.</p></br><p>Book a call with us now for a personalized product demo and see the true potential of what Apropo can do for you.</p></br><p>Act fast before it's too late!</p>",
      "title_end": "Your free trial has expired!",
      "trial_end": "<p>Your free trial on Apropo has expired and you have been downgraded to the free version. With this version, you can only have a maximum of 3 projects. If you had more than 3 projects, some of them have been archived. You can restore them from the archived projects folder in your menu.</p><br/><p>To enjoy full functionality, upgrade your account or request a demo.</p>",
      "admin": "Your trial period has ended. Select your subscription plan and fill payment details to unlock your account.",
      "user": "The trial period for your company has ended. Contact your company account owner for more details.",
      "action": "Schedule a demo",
      "action2": "Upgrade your account"
    },
    "file_processing": "Processing file",
    "link_expired": "Link is expired or invalid",
    "editor": {
      "close_editor": "Close editor",
      "connection_offline": "You are in offline mode. Worry not! Your changes have been saved.",
      "connection_restored": "Connection restored!",
      "agent_session": {
        "working": "An AI agent is working on this project. The editor is read-only until it finishes.",
        "working_for": "An AI agent is working on this project for {{name}}. The editor is read-only until it finishes.",
        "take_over": "Take over editing",
        "finished": "The AI agent finished. The project has been reloaded.",
        "taken_over": "{{name}} took over editing. The project has been reloaded."
      },
      "version_removed": "was removed by another user.",
      "version_locked": "This version is locked. Unlock the version to edit it.",
      "archive_share": "This quote has been archived by your vendor.<br/>Please contact your vendor to regain access to it.",
      "unsupported_browser": {
        "title": "Unsupported browser version",
        "editor": {
          "known": "To use pdf covers in your proposal, update your {{name}} browser to version {{version}} or higher, or open the editor in any other browser.",
          "unknown": "To use pdf covers in your proposal, update your browser to the lastest version, or open the editor in any other browser."
        },
        "proposal": {
          "known": "To view the proposal, update your {{name}} browser to version {{version}} or higher, or open it in any other browser.",
          "unknown": "To view the proposal, update your browser to the lastest version, or open it in any other browser."
        }
      },
      "removed_share": "This quote has been deleted by your vendor.<br/>Please contact your vendor for further information.",
      "removed_editor": "This project has been deleted. <br/>Please contact its owner or author.",
      "save_ai_info": "Apropo will adjust the time of each module based on previous valuations",
      "is_ai_saving": "Apropo is calculating the time for each module based on previous valuations",
      "ai_not_allowed": "Automatic estimations are not available in your plan. Try out premium account for free for 30 days to save time by automatic estimates.",
      "archive_readonly": "This proposal has been archived and is displayed in read-only mode.",
      "template_removed": "This template has been removed by another user.",
      "project_removed": "This proposal has been removed by another user.",
      "project_restored": "This proposal has been restored from the archive.",
      "readonly_info": {
        "project": "You don’t have permission to edit this project. Please contact project’s owner or author to grant you permissions.",
        "template": "You don’t have permission to edit templates. Please contact your administrator to grant you such permission."
      },
      "tag_remove": "Do you really want to remove this work type from the project?",
      "tag_remove_section": "Remove this work type from this section?",
      "tag_remove_library": "Remove this work type from library?",
      "confirm_version_removal": "Are you sure you want to remove this version?",
      "fixed_price_alert": "This section contains fixed cost items",
      "version_limit": {
        "title": "Maximum allowed versions",
        "text": "This estimate already has {{limit}} versions"
      },
      "new_version": {
        "title": "New version of the editor was detected!",
        "accept": "Reload page",
        "cancel": "Back to home page"
      },
      "idle": {
        "title": "Are you still there?",
        "text": "We've noticed you weren't using editor for some time. Don't worry, all of your changes have been saved!",
        "accept": "Continue editing",
        "loading": "Loading project data",
        "loading_template": "Loading template data",
        "cancel": "Back to home page",
        "wait1": "We are loading your data.",
        "wait2": "Please wait a few seconds."
      },
      "connection": {
        "title": "Connection error",
        "loading": "Reloading...",
        "accept": "Reload project",
        "accept_template": "Reload template",
        "text": "We've encountered a problem while applying last change to your project. Please reload it and try again.",
        "text2": "If the problem occurs again after reloading, please contact us."
      },
      "ai": {
        "success": {
          "title": "Your estimate is ready!",
          "file_subtitle": "Estimate has been generated based on the following files:",
          "read": "Read",
          "error": "Error reading the file",
          "error2": "This file wasn't included in generating the estimate."
        },
        "awaiting": {
          "title": "This project is being generated by our AI.",
          "text": "Please wait here until it finishes or come back later."
        }
      }
    },
    "library": {
      "library_is_already": "This module is already in Library or is awaiting approval from Manager or Admin in your company.",
      "library_name_required": "Please name your element before adding it to the library.",
      "library_name_error": "Couldn't add element to the library.",
      "added_manager": "Successfully added '{{name}}' to the library",
      "added_pending": "'{{name}}' was added to the library and is awaiting approval from Manager or Admin in your company.",
      "accept": {
        "title": "Accept and add to library",
        "text": "This {{level}} will be added to library",
        "text_nested": "This {{level}} will be added to library under {{parentName}} {{parentLevel}}"
      },
      "discard": {
        "title": "Discard and remove",
        "text": "This {{level}} will be removed from the library."
      }
    },
    "pdf": {
      "doc_remove": {
        "title": "Last page",
        "title_all": "Remove document",
        "content": "Are you sure you want to remove last page from \"{{docName}}\" file? This file will be removed from the project.",
        "content_all": "Are you sure you want to remove \"{{docName}}\" file from the project?"
      }
    },
    "announcements": {
      "title": "Updates!",
      "subtitle": "Dear user! Since your last login the following updates have been implemented:",
      "subtitle_singular": "Dear user! Since your last login the following update has been implemented:",
      "demo": "Wanna get a demo of the upgrades? Go right ahead!"
    }
  },
  "bars": {
    "menu": {
      "pro_user": "Upgrade plan",
      "subscription": "Subscription & Team",
      "team": "My team",
      "invite": "Invite team member",
      "archived": "Archived projects",
      "feedback": "Feedback",
      "settings": "Settings",
      "logout": "Logout",
      "boards": "Boards",
      "board_switch": "Switch board",
      "board_add": "Create board"
    }
  },
  "impersonation": {
    "banner": {
      "viewing_as": "You are viewing {{subject}} as {{actor}}.",
      "fallback_actor": "root user",
      "exit": "Exit impersonation"
    },
    "handoff": {
      "invalid": "Impersonation link is invalid or expired.",
      "return_to_login": "Return to login"
    }
  },
  "views": {
    "auth": {
      "jira": {
        "title": "Integrate with Jira",
        "desc": "This integration will allow you to quickly export Apropo proposals to new Jira projects. Tickets corresponding to your proposal elements will be automatically created in the new Jira projects.",
        "tech_desc": "Jira will have limited access to your projects (name, creation date, deadline), as well as sections, modules, features & tasks, from following domain: ",
        "button": "Accept"
      },
      "sso": {
        "microsoft": {
          "in": "Sign in with Microsoft",
          "up": "Sign up with Microsoft"
        }
      }
    },
    "login": {
      "placeholder_email": "E-mail",
      "email_error": "Enter valid e-mail or login",
      "no_password": "Forgot password?",
      "no_account": "Don't have an account?",
      "sign_here": "Sign up here",
      "remember": "Remember me",
      "activate": "Your account is not active. Please check your email for a confirmation link, or request a new one by clicking on a button below.",
      "resend": "Resend activation link"
    },
    "register": {
      "confirm": "Start a {{trialDays}}-day Free Trial",
      "confirm_invite": "Start using apropo",
      "successful": "Activation code was sent to your email: {{email}}. Please type it here to activate your account."
    },
    "retrieve_password": {
      "forgotten": "Forgot your password?",
      "desc": "Enter the email address associated with your account and we’ll send you a link to reset your password.",
      "send": "Send link to reset password",
      "back": "Back to login"
    },
    "activate": {
      "wait": "Verifying activation token...",
      "error": "Activation link expired.",
      "placeholder_code": "Activation code"
    },
    "board": {
      "create_first": "Choose name of your first board",
      "start_trial": "Start your free trial now",
      "desc_1": "Prepare detailed, good-looking price proposals 4 times faster than now!",
      "desc_2": "Engage buyers, get their insights and close more deals than ever.",
      "info_1": "Pricing with less developer input",
      "info_2": "Customer recording (like Hotjar)",
      "info_3": "Faster quoting time",
      "info_4": "Smart templates",
      "start": "Start using Apropo",
      "trial": "{{trial}} days of free trial",
      "trial_full": "Get {{trial}} days of free trial.",
      "free_cancel": "Cancel any time.",
      "create": "Create new board",
      "add": "New Board",
      "choose": "Log in to one of your boards",
      "name": "Board name",
      "type": "Select board plan",
      "edit_name": "Change name",
      "members": "Board members",
      "delete": "Remove board",
      "deletion_alert": {
        "title": "Are you sure you want to remove this board?",
        "confirm": "Please type board name to confirm"
      },
      "types": {
        "free": "Free",
        "trial": "Trial",
        "standard": "Standard",
        "premium": "Premium",
        "enterprise": "Enterprise"
      }
    },
    "active": {
      "columns": {
        "todo": "todo",
        "in_progress": "in progress",
        "done": "done"
      },
      "popup": {
        "actions": "Actions",
        "desc": "Project description",
        "no_desc": "No description",
        "name": "Enter project's name",
        "attachments": "Attachments",
        "pdf_proposals": "PDF proposals",
        "pdf_cover": "PDF proposal cover",
        "tags": "Tags",
        "members": "Team members",
        "contractors": "External Contractors",
        "activity": "Activity",
        "archive_question": "Are you sure you want to archive this project?",
        "archive_accept": "Yes, archive",
        "write_comment": "Write a comment",
        "pick_emoji": "",
        "no_members": "Invite other users to assign them to this project",
        "no_observers": "No other user is assigned to this project.",
        "remove_user": "Remove user from project",
        "remove_owner": "Remove user from project",
        "add_user": "Add user to project",
        "add_owner": "Add new owner of the project",
        "add_comment": "Add comment"
      },
      "new_project": "New Project",
      "no_deadline": "No Deadline set",
      "search_tag": "Search for tags",
      "search_member": "Filter your team members",
      "new_tag": "Create and add '{{value}}' tag",
      "member_invite": "Invite new team member",
      "emptyShared": "No shared projects yet",
      "sharedEmpty": {
        "title": "It's quiet here for now...",
        "description": "Once another company shares a project with you for estimation, it will appear right here. We'll also send you an email notification so you don't miss it."
      }
    },
    "project": {
      "about": "About project",
      "archived": "Archived",
      "estimate": "Estimate",
      "pdf_editor": "View PDF",
      "members": "Members",
      "delete": "Delete project",
      "create": "Yes, create",
      "change_owner": "Change owner",
      "add_owner": "Add owner",
      "comments_full": "This project includes comments. Do you want to save them in the duplicated project?",
      "project_template": {
        "title": "Create template",
        "title_edit": "Edit template",
        "title_save": "Save template",
        "title_full": "Create template from project",
        "desc": "You can save this project as a custom template. It will retain all the settings and values.",
        "desc2": "You can browse and use templates in the ",
        "desc3": " tab.",
        "save_as": "Save as template",
        "success": "Template created!",
        "success_save": "Template saved!",
        "fields": {
          "name": "Template name",
          "type": "Template type",
          "desc": "Template description"
        }
      },
      "table": {
        "platform": "Platform",
        "time": "Time spent (hours)",
        "budget": "Budget ($)",
        "total": "Total:"
      }
    },
    "archived": {
      "name": "Name",
      "category": "Category / Type",
      "tags": "Tags",
      "archived": "Archived",
      "members": "Members Assigned",
      "projects": "projects",
      "show": "Show",
      "not_found": "No archived projects found",
      "restore_question": "Are you sure you want to restore this project?",
      "restore_accept": "Yes, restore",
      "menu": {
        "details": "Show details"
      }
    },
    "notifications": {
      "message": "Message",
      "date": "Date and time"
    },
    "new_project": {
      "title": "Create new project",
      "title_short": "Create project",
      "name": "Project name",
      "enter_name": "Enter new project name",
      "work_type_desc": "This field represents categories of work to be performed, ie. Frontend, Backend or QA. Select some from the list or start typing and press Enter to add custom ones.",
      "enter_system": "Choose work types (or type your own)",
      "level": "Level of detail",
      "proposal_pdf_upload": "Upload PDF presentation files (optional)",
      "proposal_pdf": "PDF presentation",
      "complexity": "Complexity level",
      "import_template": "Create template from XLS",
      "deadline": "Project deadline",
      "enter_deadline": "Choose deadline of the project",
      "finish": "Do you confirm all the settings and wish to create the project?",
      "desc": "Project description (optional)",
      "enter_desc": "Provide project's description",
      "change_template": "Select template",
      "change_file": "Change PDF file",
      "pdf_drag": "Drag your PDF here or ",
      "pdfs_drag": "Drag your PDFs here or ",
      "pdf_drop": "Drop file here",
      "pdfs_drop": "Drop file(s) here",
      "pdf_browse": "browse",
      "pdf_no_file": "No PDF file added",

      "prompt": "Prompt",
      "prompt_info": "Amazon Bedrock doesn't store or log your prompts and completions. Amazon Bedrock doesn't use your prompts and completions to train any AWS models and doesn't distribute them to third parties.\nAmazon Bedrock has a concept of a Model Deployment Account—in each AWS Region where Amazon Bedrock is available, there is one such deployment account per model provider. These accounts are owned and operated by the Amazon Bedrock service team. Model providers don't have any access to those accounts. After delivery of a model from a model provider to AWS, Amazon Bedrock will perform a deep copy of a model provider’s inference and training software into those accounts for deployment. Because the model providers don't have access to those accounts, they don't have access to Amazon Bedrock logs or to customer prompts and completions.",
      "enter_prompt": "Describe what your project is about",
      "upload_files": "Upload files",
      "upload_files_full": "Upload files based on which the project scope estimate should be generated, e.g. project brief, RFP, SoW or other materials from your client.",
      "creator_title": {
        "manual": "Manual",
        "ai": "AI"
      },
      "ai_info": {
        "start": "This is a beta version of the AI estimates feature. The soonest upgrades will include:",
        "f1": "• Adding files to the prompt",
        "f2": "• Generating the scope & estimates in a selected template",
        "f3": "• Generating the scope & estimates based on your Library items and your previous projects"
      },
      "ai_creator": {
        "language": "Language",
        "generate": "Generate",
        "level": "Level of detail",
        "generate_scope": "Scope",
        "generate_descriptions": "Descriptions",
        "generate_estimates": "Estimates"
      },

      "wait": "Please wait",
      "saving": {
        "project": "Saving project",
        "file": "Saving file"
      },
      "file": "File",
      "file_error": "has not been uploaded due to ",
      "file_actions": {
        "skip": "Skip file",
        "retry": "Retry"
      },
      "payment_success": "Template has been purchased successfully."
    },
    "templates": {
      "edit_info": "Edit template info",
      "edit_estimate": "Edit estimate",
      "change_color": "Change template color",
      "set_color": "Save color",
      "no_templates": "No templates found",
      "custom_templates": "My templates",
      "apropo_templates": "Apropo templates",
      "default_template": "Default template",
      "search": "Search templates",
      "card": {
        "preview": "Preview",
        "preview_title": "{{name}} - Preview",
        "open": "Open",
        "open_edit": "Open & Edit",
        "read_more": "read more",
        "select": "Choose",
        "create_project": "Create a project"
      },
      "blank": {
        "title": "Blank project",
        "desc": "Create your project from scratch",
        "desc_alt": "Create your project from scratch or"
      },
      "xls": {
        "title": "Import spreadsheet",
        "desc": "Upload from your computer"
      }
    },
    "import": {
      "title": "Import from spreadsheet",
      "confirm": "Finish import",
      "steps": {
        "1": "Import file",
        "2": "Select sheet",
        "3": "Select import area",
        "4": "Choose modules",
        "5": "Preview imported data"
      },
      "modes": {
        "fast": "Fast",
        "custom": "Custom"
      },
      "drop_active": "Drop file here",
      "drop_inactive": "Select a XLS file from your computer",
      "drop_inactive_sub": "or drag and drop it here",
      "auto_import": "Auto import (if using ",
      "template": "our template",
      "sheets_title": "Select which sheets should be used for import",
      "import_error": "We've encountered problems processing your file",
      "xls_error": {
        "title": "File is damaged",
        "subtitle": "Try opening it in Excel to check if it's not corrupted, save it and try again here. If the problem persists, please contact our support at "
      },
      "next_step": "Next step",
      "prev_step": "Back",
      "breakdown_area": "Select maximal import area for breakdown table (tasks, work types)",
      "summary_area": "Select maximal import area for summary table (work types, rates, time, cost)",
      "draw_area": "Mark area in table",
      "save_draw_area": "Save selection",
      "clear_draw_area": "Clear selection",
      "clear_rows": "Remove selection",
      "select_rows": {
        "0": "Select section rows",
        "1": "Select module rows",
        "2": "Select feature rows"
      },
      "select_info": {
        "name": "Work type name",
        "time": "Time (hours/days)",
        "rate": "Rate",
        "cost": "Total price"
      },
      "select_column": "Select column with work type's data",
      "select_system": "Select work type",
      "remove_column": "Cancel work type import",
      "text_column_add": "Import more text columns",
      "next_text_column": "Text column {{index}}",
      "add_column": "Import work type",
      "sub_titles": {
        "modules": "Level of detail",
        "work_types": "Estimates",
        "description": "Descriptions"
      },
      "time": "Estimation unit: ",
      "template_save": "Save as template",
      "cancel": "Cancel import",
      "no_max": "No max",
      "configs": {
        "title": "Configuration",
        "placeholder": "Saved configurations",
        "save": "Save this configuration",
        "create": "Create new",
        "saving": "Saving configuration",
        "default_set": "Set as default",
        "empty": "No saved configurations",
        "name": "Set your new configuration's name",
        "delete_question": "Are you sure you want to delete this configuration?"
      }
    },
    "team": {
      "title": "My Team",
      "contractors": "External contractors",
      "seats": "{{seats}} seats available",
      "add": "Add user",
      "name": "Full name",
      "role": "Role",
      "email": "Company E-mail",
      "level": "Level",
      "stack": "Stack type",
      "status": "Status",
      "company": "Company",
      "status0": "Inactive",
      "status1": "Active",
      "status-1": "Invitation sent",
      "change_user": "Change to regular user",
      "change_admin": "Change to admin user",
      "admin": "Admin",
      "remove_member": "Do you really wish to remove {{name}} from this board?",
      "remove_contractor": "Do you really wish to remove {{name}} from your company?",
      "modal_title": "Edit team member",
      "not_found": {
        "team": "No team members found",
        "contractors": "No contractors found"
      },
      "projects_visibility": {
        "title": "Projects visibility",
        "all": "All projects",
        "assigned": "Assigned projects",
        "for_admin": "Admin can only see all projects.",
        "for_manager": "Manager can only see all projects.",
        "helper_all": "Your Admin set you can see all projects.",
        "helper_assigned": "Your Admin set you can only see projects you are assigned to."
      },
      "mcp_sso": {
        "column": "MCP SSO",
        "manage": "Manage MCP SSO",
        "manage_for": "MCP SSO access for {{name}}",
        "retry": "Retry MCP synchronization",
        "reset": "Reset MCP SSO identity",
        "reset_for": "Reset MCP SSO identity for {{name}}",
        "reset_warning": "The current identity and sessions will be revoked. The user must connect SSO again.",
        "resend": "Resend connection email",
        "level": "Maximum access",
        "level_none": "No access",
        "revoke_confirmation": "Type the confirmation text to revoke access",
        "confirmation_hint": "Enter: {{confirmation}}",
        "status": {
          "provisioning": "Provisioning",
          "awaiting_link": "Waiting for user connection",
          "active": "Connected",
          "sync_error": "Synchronization error",
          "revoked": "Revoked"
        }
      }
    },
    "subscription": {
      "titles": {
        "current": "Current plan",
        "details": "Payment Details",
        "payments": "Recent payments"
      },
      "actions": {
        "change_plan": "Change plan",
        "add_coupon": "Add coupon",
        "edit_method": "Edit payment details",
        "show_methods": "Show payment methods",
        "no_methods": "No payment methods",
        "show_history": "Show payment history",
        "email_invoices": "Email invoices",
        "email_invoices_success": "Preferences saved! Future invoices will be emailed to {{email}}"
      },
      "details": {
        "next": "Next payment",
        "ends": "Subscription ends",
        "trial": "Trial",
        "amount": "Amount",
        "amount_net": "Amount (net)",
        "email": "Email address",
        "method": "Method",
        "default_card": "Default card",
        "coupon": "Active coupon",
        "using_trial": "Currently, you are using the Trial version of Apropo",
        "trial_expires": "Trial expires",
        "book_demo": "Book a demo",
        "no_card": "No card added"
      },
      "dialogs": {
        "plan": "Select new subscription plan",
        "methods": "Your saved payment methods",
        "history": "Your payment history",
        "coupon": "Add coupon",
        "coupon_alert": "You already have an activated coupon. Adding a new one will deactivate it."
      },
      "special_plan": {
        "intro": "Contact us to customize the perfect plan",
        "for_org": "For organizations with a larger volume of requirements",
        "talk": "Let's talk",
        "we_offer": "We offer the best in matching you with others based on who you are and what you want.",
        "connect": "Connect with us to get access to these additional features.",
        "contact_message": "Hi, I would like to talk about customizing a plan to fit my needs. Please feel free to contact me."
      },
      "next_billing": "Your next billing date is",
      "current_method": "Your default payment method is",
      "no_payments": "Your payment history is empty",
      "no_methods": "No payment methods added",
      "type": "Type",
      "date": "Date of purchase",
      "price": "Price",
      "amount_gross": "Amount (gross)",
      "payment_status": {
        "new": "Awaiting payment",
        "pending": "Pending",
        "end": "Completed",
        "cancel": "Canceled",
        "failed": "Failed",
        "succeeded": "Succeeded",
        "refunded": "Refunded"
      },
      "invoice": "Invoice",
      "sub": "Subscription",
      "sub_payment": "Subscription payment",
      "tral_left": "{{days}} days left",
      "status": "Payment status",
      "remove": "Remove card",
      "default_set": "Set card as default payment method",
      "types": {
        "subscription": "Subscription",
        "template": "template"
      },
      "methods": {
        "manufacturer": "Card manufacturer",
        "number": "Last four digits",
        "valid_to": "Valid to"
      },
      "plan": {
        "best": "Best offer",
        "popular": "Popular",
        "get": "Select plan",
        "get_old": "Get a quote",
        "request": "Request price",
        "choose": "Choose the plan that fits you best",
        "success": "Success! You can use your subscription right now.",
        "cancel": "Are you sure you want to cancel your subscription and return to free version?",
        "saved_method": "Payment will be made with your saved card",
        "active_projects": "active projects",
        "company_size": "User seats",
        "estimates_month": "Active estimates",
        "see_features": "See features",
        "request_success": {
          "title": "Your request has been sent!",
          "content": "Our Team will be in touch with you in up to 2 hours."
        },
        "no_success": {
          "title": "We couldn't process your payment",
          "content_start": "You can finish it",
          "here": "here",
          "content_end": "now, or later using the link in your",
          "history": "payment history",
          "expiration": "Link is valid for 24 hours, after which your subscription will be canceled."
        },
        "features": {
          "comparison": "See plans comparison",
          "estimation": "Estimation features",
          "sales": "Sales features",
          "budget": "Budget management tools",
          "consulting": "Consulting"
        },
        "custom": {
          "talk": "Talk to sales",
          "get": "Get a custom offer!",
          "point1": "Need more users?",
          "point2": "Less users but more projects?",
          "point3": "Different set of features?"
        },
        "change_to_free": {
          "title": "Do you want to switch to Free plan?",
          "content": "If you want to switch to the Free plan, write an email to "
        }
      }
    },
    "settings": {
      "photo_upload": "Upload new",
      "logo_upload": "Upload company logo",
      "logo_change": "Change company logo",
      "password_changed": "Password changed successfully",
      "project_type_add": "Create new project type",
      "menu": {
        "profile": "Profile",
        "passwd": "Password",
        "company": "Company",
        "project": "Projects",
        "currency": "Currency",
        "rates": "Rate card",
        "fte": "FTE",
        "estimation_unit": "Estimation unit",
        "domain": "Domain",
        "project_types": "Project types",
        "labels": "Labels",
        "api_keys": "API keys",
        "api_mcp_keys": "API & MCP",
        "integrations": "Integrations",
        "upgrade": "Upgrade plan",
        "delete": "Delete account",
        "payment": "Payment details"
      },
      "menu_full": {
        "profile": "Profile settings",
        "passwd": "Change password",
        "company": "Company details",
        "project": "Projects settings",
        "currency": "Default currency",
        "rates": "Rate card",
        "fte": "FTE settings",
        "domain": "Proposal domain",
        "project_types": "Manage project types",
        "no_project_types": "You have no project types added",
        "labels": "Manage labels",
        "no_labels": "You have no labels added"
      },
      "language": "Language",
      "api_keys": {
        "description": "Create and revoke MCP API keys for active team members in your company.",
        "create": "Create API key",
        "form": "API keys form",
        "name": "Name",
        "user": "Assigned user",
        "scope": "Scope",
        "key": "API key",
        "created": "Created",
        "empty": "No MCP API keys have been created yet.",
        "secret_title": "Copy your API key now",
        "secret_warning": "This secret is shown only once. Store it in a secure password manager before closing this dialog.",
        "revoke_title": "Revoke API key",
        "revoke_text": "Revoke \"{{name}}\"? Any MCP client using this key will lose access immediately.",
        "revoke": "Revoke key"
      },
      "mcp_sso": {
        "title": "MCP access with SSO",
        "description": "Connect Google or Microsoft after your company administrator grants MCP access. API keys continue to work independently.",
        "level": "Maximum access",
        "level_none": "No access",
        "status": "Status",
        "provider": "Connected provider",
        "connected_at": "Connected at",
        "connect_google": "Connect Google",
        "connect_microsoft": "Connect Microsoft",
        "ask_admin": "Ask your company administrator to grant MCP SSO access.",
        "callback_error": "The SSO connection could not be completed.",
        "callback_cancelled": "The SSO connection was cancelled."
      },
      "language_help": "Choose your preferred language for the application",
      "info": {
        "rates": "Select work types and set their default rates. They will be used in your company's future projects.",
        "currency": "Select default currency for your company's future projects.",
        "fte": "Set the FTE (Full-time Equivalent) values for your company. Set how many hours-a-day, days-a-week and days-a-month do you employees work. This data will be used to calculate the calendar time of your projects.",
        "domain": "Add your own domain for sharing proposals."
      },
      "projects": {
        "color_select": "Change color of your custom work type",
        "color_select_dialog_title": "Select color for \"{{name}}\"",
        "use_domain": "Use this domain in proposals",
        "domain_enter": "Enter your domain",
        "domain_placeholder": "eg.: proposal.company.co",
        "ssl": "SSL certificate",
        "no_use_domain": "Use Apropo domain in proposals",
        "cname_record": "CNAME record",
        "cname_name": "CNAME name",
        "cname_value": "CNAME value",
        "not_ready": "Not ready",
        "labels": {
          "remove_alert": "Do you really want to remove this label?",
          "add_label": "Add label",
          "type_label_name": "Type label name",
          "type_new_label_name": "Type label name to create it",
          "select_color": "Select background color:",
          "select_font_color": "Select font color:"
        },
        "rate_card": {
          "title": "Default {{timely}} rates",
          "not_found": "No rates found",
          "currency": "Sales {{timely}} rate ({{currency}})",
          "currency_select": "Sales {{timely}} rate",
          "company_currency": "Cost {{timely}} rate ({{currency}})",
          "company_currency_select": "Cost {{timely}} rate",
          "new_work_type": "Type new work type name",
          "new_team_member": "Type new team member name",
          "edit_alert": "System-installed Work Types can't be edited.",
          "remove_error": {
            "title": "Could not remove",
            "content": "{{workTypeName}} is used in one or more projects."
          },
          "remove_prompt": {
            "category": {
              "title": "Do you wish to remove this Work Type and Roles it includes?",
              "content": "Deleting this Work Type WILL NOT affect any existing projects or templates. The deleted Work Type will no longer be available in your Work Types list when creating a new project."
            },
            "role": {
              "title": "Do you wish to remove this Role?",
              "content": "Deleting this Role WILL NOT affect any existing projects or templates. The deleted Role will no longer be available in your Roles list for this Work Type."
            }
          }
        },
        "domain_dialog": {
          "title": "Next steps",
          "subtitle": "Thank you for adding your own domain for sending proposals!",
          "please": "Please follow the below instruction to make it active:",
          "steps": {
            "1": "In the next 24 hours, we will set the proper CNAME records in our system. They will be displayed in 2 the fields below the input with your domain.",
            "2": "Please set those records in your domain's DNS.",
            "3-1": "Up to 24 hours from setting the records in your domain's DNS, the",
            "3-2": " domain will become active and all your proposals will be shared with your clients from this domain. The exact activation time of your domain is dependable on your DNS settings."
          },
          "final1": "In case of having any questions or troubles with setting up your domain, please reach out to our Support Team at",
          "final2": "they will be happy to guide you through the process.",
          "checkbox": "I acknowledge the process of adding my own domain is clear to me."
        }
      },
      "popup": {
        "title": "Do you want to delete your account?",
        "text": "Enter password to proceed. All data will be lost.",
        "delete": "Delete account"
      }
    },
    "session": {
      "customer": "Customer email",
      "date": "Session start",
      "duration": "Duration",
      "ip": "Session IP",
      "location": "Session location",
      "skip": "Skip inactivity",
      "anonymous": "Anonymous",
      "status": "Status",
      "done": "Finished",
      "progress": "In progress",
      "first": "First recording",
      "last": "Last recording",
      "total": "Recordings",
      "estimation": "View proposal",
      "info_pr": "Project info",
      "info_se": "Session Details",
      "play": "Replay session",
      "heatmap": "Show usage heatmap",
      "skip_inactive": "Skip inactivity"
    },
    "jira": {
      "text1": "Create complete project backlog in less than 1 minute by importing Apropo estimates directly in Jira.",
      "text2": "See the below video, install the plugin in your Jira account and start saving hours on creating project backlogs:",
      "button": "Set up integration"
    },
    "library": {
      "title": "Elements Library",
      "back": "Back to proposal",
      "suggestions": "Pending suggestions",
      "suggestions_back": "Back to library",
      "pending_empty": "No more Elements awaiting confirmation."
    },
    "bt": {
      "project_used": "(already used)",
      "select_project": "Select Jira project",
      "select_project_full": "Select the project from your Jira to which the tasks should be exported",
      "select_workspace": "Select Jira workspace",
      "select_workspace_full": "Select your Jira workspace to which the tasks should be exported",
      "connect_new_workspace": "Connect new Jira workspace",
      "jira_access_error": {
        "accept": "Re-authorize Jira"
      },
      "time_tracking_error": {
        "content": "The project you selected does not contain the fields necessary for time estimates.",
        "content2": "If you want to export the time estimates to Jira, set the “Time tracking” and “Original estimate” fields in Jira for every issue type of the project and export again.",
        "retry": "I've added Time Tracking fields",
        "export_without": "Export without estimates",
        "cancel": "Cancel export"
      },
      "title": "Budget Tracking",
      "import_title": "Set up budget tracking",
      "export_title": "Export to Jira",
      "open_title": "Open budget tracking",
      "estimate": "Estimate",
      "spent": "Spent",
      "diffh": "Left",
      "diff": "Spent (%)",
      "following_version": "Export task from the following version",
      "levels_of_estimate": "Export & map the following levels of estimate",
      "work_type": "Export estimates from the following work types",
      "multiple_work_types": "If one task has multiple work types",
      "single_ticket_work_type": "Import estimates from all work types to single ticket",
      "split_ticket_work_type": "Create separate task for every work type",
      "split_levels": "Create task for every work types only for the following issue types:",
      "project_key": "Project key",
      "enter_project_name": "Enter project name",
      "enter_project_key": "Enter project key",
      "no_view_level": "This project does not use {{levelName}} in it's structure",
      "import_data_form": "Select Jira project to import the data from",
      "user_with_work_types": "Pair user timelogs with work types",
      "set_up": "Set up Budget Tracking",
      "import_user": "import user timelogs to",
      "user_with_apropo_users": "Pair Jira users with Apropo users",
      "user_with_apropo_users_and_work_types": "Pair Jira users with Apropo users and their timelogs with work types",
      "import_tickets": "Import non-paired tickets",
      "tickets_not_created_in_export": "For the tickets not created in Jira through Apropo export",
      "import_tickets_tag": "Import tickets with the tag",
      "add_import_rule": "Add import rule",
      "tag": "Tag",
      "enter_select_name": "Enter select name",
      "refresh_notice": "Dear user, 100 task items from Jira are being processed at the moment, come back to us in 5 minutes",
      "open_export_bt_first": "Dear user, please export your budget tracking before Setup",
      "user": {
        "apropo": "Apropo user",
        "jira": "Jira user"
      },
      "info_create_project": {
        "title": "Project is being exported",
        "text1": "You can close this window to observe the progress.",
        "text2": "After the export is completed, refresh your Jira site to see the imported tickets."
      },
      "project_link": "Link to the project in Jira:",
      "select_sections": "Export the following sections",
      "type": "Type",
      "upload_progress": "Upload progress. All issues: {{allIssues}} Exported: {{exported}}%",
      "upload_alert": "Errors from Jira",
      "show_upload_errors": "Show errors",
      "uploaded_successfully": "Project uploaded successfully",
      "uploaded_with_warnings": "Project uploaded with warnings",
      "something_went_wrong": "Something went wrong"
    },
    "editor": {
      "ai_gen_progress": "I'm generating your project scope. . .",
      "stop_ai_gen": "Stop generating",
      "estimate_in": "Show estimate in",
      "estimate_format": "Estimation format",
      "summary_columns": "Summary Columns",
      "breakdown_columns": "Breakdown Columns",
      "time_in": "Show duration in",
      "estimate_in_alert": {
        "text1": "As per your company’s man-day settings, your estimates will be divided by {{hours}} and rounded to 2 decimal places.",
        "text2": "Do you wish to proceed?"
      },
      "show_prices": "Show prices",
      "price_simulation": "Price simulation",
      "reset_configuration": "Reset configuration",
      "min_max": "Min - Max",
      "uses_buffers": "Imported estimates include buffers",
      "desc_change": "Change description",
      "desc_mode": "Description mode",
      "export_title": "Proposal presentation for project",
      "save": "Save",
      "is_saving": "Saving project",
      "save_ai": "Auto Estimate",
      "tags_edition": "Add & remove work types",
      "tags_edition_library": "Add & hide work types",
      "tags_edition_change": "Change work types",
      "share": "Share",
      "export": "Export",
      "import": "Import from XLS",
      "export_name": {
        "document": "Save as PDF",
        "document_horizontal": "Horizontal page layout",
        "document_vertical": "Vertical page layout",
        "pdf": "Export to PDF",
        "xls": {
          "unstyled": "Export to XLS",
          "styled": "Export to XLS (formatted)"
        },
        "styled": "With formatting",
        "unstyled": "Without formatting"
      },
      "pdf_archived_export_alert": {
        "title": "This project is archived",
        "content": "To export this project to PDF, restore it from the archive."
      },
      "cell_settings": {
        "title": "Cell settings",
        "format": "Cell format"
      },
      "row_type_change": "Change row type",
      "section_type_change": "Section mode",
      "section_columns": "Column settings",
      "section_columns_full": "\"{{name}}\" column settings",
      "export_error": "Failed to export PDF. Please try again.",
      "proposal": "Generate proposal",
      "save_template": "Save as template",
      "cancel": "Cancel changes",
      "delete": "Delete",
      "description": "Change description",
      "description_add": "Add description",
      "child_below": "This item includes {{childrenAmount}} child item. Click to expand.",
      "children_below": "This item includes {{childrenAmount}} child items. Click to expand.",
      "generate_us": "Generate user story",
      "generated_us": "User story already generated for \"{{name}}\"",
      "duplicate": "Duplicate {{type}}",
      "add_to_library": "Add to library",
      "price": "Price",
      "units": "Quantity",
      "unit_price": "Unit price",

      "export_v2": {
        "title": "Export to PDF - Configuration",
        "export_button": "Export PDF",
        "format": "Page Format",
        "orientation": {
          "label": "Page orientation",
          "value": {
            "portrait": "A4 (Portrait)",
            "landscape": "A4 (Landscape)"
          }
        },
        "filename": "File Name",
        "filename_helper": "Name of the PDF file (e.g. proposal.pdf)",
        "custom_width": "Custom Width",
        "custom_height": "Custom Height",
        "export_type": "Export Type",
        "export_type_vector": "Vector (crisp, smaller file)",
        "export_type_raster": "Raster (image-based, larger file)",
        "scale": "Scale (zoom)",
        "wait_until": "Wait Until (loading)",
        "delay": "Extra delay",
        "delay_helper": "Additional wait time for animations/lazy-loading (0-5000ms)",
        "print_background": "Include colors & backgrounds",
        "print_background_ex": "Exclude colors & backgrounds",
        "apply_visibility": "Apply Visibility settings",
        "apply_visibility_ex": "Ignore Visibility settings",
        "use_borders": "Draw borders around table elements",
        "use_borders_ex": "Don't draw borders around table elements",
        "wait_for_animations": "Wait for animations (+ ~2 seconds)",
        "template_pdf_url": "Template PDF URL",
        "template_pdf_url_helper": "URL of the template PDF to merge (e.g. https://example.com/template.pdf)",
        "insert_page_place": "Insert at Page",
        "insert_page_place_helper": "Page number where to insert the PDF (0 = beginning, 1 = after page 1, etc.)"
      },
      "labels": {
        "add_label": "Add label",
        "company": "Company labels",
        "project": "Project labels",
        "template": "Template labels",
        "not_found": "No labels found",
        "not_found_in_project": "No labels used in project",
        "not_found_in_template": "No labels used in template"
      },
      "estimate": {
        "hours": "Estimate (hours)",
        "days": "Estimate (days)",
        "show": "Expand work type columns",
        "hide": "Collapse work type columns into single column",
        "alert": {
          "title": "Combined value",
          "content": "Expand the column to edit."
        },
        "buffer_value_alert": {
          "title": "Buffered value",
          "content": "Edit the value in the field to the left."
        }
      },
      "price_library_info": {
        "text": "Rates & currency used in Elements Library can set up in ",
        "link": "Project Settings"
      },
      "rate_diff": "Rate difference",
      "versions": {
        "rename": "Change version name",
        "remove": "Remove version",
        "lock": "Lock version",
        "unlock": "Unlock version",
        "locked": "This version was locked by project’s owner",
        "hidden": "This version will be hidden in proposals"
      },

      "resize_alert": {
        "title": "Pro tip",
        "text": "You can change the column width only in the selected section by holding the CTRL or CMD button and dragging the column width."
      },

      "average_breakdown_rate_info": "Due to different rates for the given team members, it is their average rate that will be used for calculating the prices in the breakdown.",
      "average_breakdown_rate_info_tooltip": "Rate used for price calculation in the Breakdown is the average rate of the team members assigned in the Summary, due to different rates of the assigned team members.",
      "risk_alert": "Risk buffer for this project is set to {{percent}}%. The number you put in will be multiplied by {{percent}}%",
      "children_value_alert": {
        "title": "This {{level}} includes sub-estimates.",
        "reset": "Overwrite and reset them",
        "split": "Overwrite them proportionally",
        "automation_title": "Percentage calculation",
        "automation": "One or more sub-estimates use percentage calculation. This action will remove the percentage calculation from these estimates. Do you want to continue?"
      },
      "different_alert": {
        "text": "Provided value was updated because it was split between {{childElements}} child components to an irrational number and then rounded{{rounding}}.",
        "rounding": {
          "0": " to 2 decimal points",
          "1": " down",
          "2": " up",
          "3": ""
        }
      },
      "different_price_dialog": {
        "text1": "The total price of the project doesn't match the sum of prices of the project's sections because you are using the price rounding feature, present estimates in days or because you have added team members with different {{timely}} rates in the Summary section.",
        "text1_wt": "The displayed price for {{workType}} shows different value to the result of multiplication of total hours for {{workType}} and hourly rate, which equals ",
        "text3_wt": "To ensure that the price reflects the correct value, either:",
        "text2": "To ensure that the sum of the prices of all sections matches the total price indicated in the Summary, either:",
        "point1": "Use the same hourly rates for Team Members added within the same Work Type.",
        "point2": "Display your estimate in hours.",
        "point3": "Turn Price rounding off."
      },
      "price_rounding_alert": {
        "text": "The price rounding is on. The sum of prices from the Breakdown may differ from the Total price indicated in the Summary.",
        "text2": "To turn off the price rounding, "
      },
      "soft_rounding_alert": {
        "text": "Decimal places hiding is on. The sum of prices from the Breakdown may differ from the Total price indicated in the Summary.",
        "text2": "To turn off the decimal places hiding, "
      },
      "hard_rounding_alert": {
        "text": "Hard rounding is applied to the {{roundLevel}} level. The number of {{times}} shown for {{roundLevel}} may slightly differ from the sum of {{times}} of its sub-components.",
        "text2": "To turn off the hard rounding, "
      },
      "hidden_work_type_price_alert": {
        "title": "Price column includes hidden work types",
        "line1": "The price may not match the visible time estimates because includes the cost of {{workTypes}} which are hidden in this section.",
        "line1_alt": "The price may not match the visible time estimates because includes the cost of {{workTypes}} which is hidden in this section.",
        "line2": "To change it, go to Price column settings and set the “Include hidden work types in line item price” to Off."
      },
      "low_depth_rounding_alert": {
        "title": "Rounding is applied only to {{level}} and higher",
        "text": "The rounding feature is applied only from {{level}} upwards, but it is not applied to lower level items ({{levels}}). As a result, the sum of estimates in {{lower_level}} may not match the sum of estimates in {{level}}."
      },
      "duplicates": "Duplicates",
      "alert": "Look out! \nThe rate you’ve given is different from the rate offered by the developer.",
      "revert_value": "Restore value to auto calculated one",
      "breakdown_hours_alert": {
        "title": "Values in breakdown",
        "content": "To change the value, scroll down to Estimate Breakdown and edit hours for specific tasks or click on the “eye” icon that you see on the left."
      },
      "timeline_hours_alert": {
        "title": "Values in timeline",
        "content": "To change the value, scroll down to Timeline and edit hours for specific tasks or turn off timeline usage."
      },
      "timeline_time_alert": {
        "title": "Values in timeline",
        "content": "To change the value, scroll down to Timeline and edit values in timeline months."
      },
      "timeline_team_alert": {
        "title": "Values in timeline",
        "content": "This field is locked when Project Timeline is visible or when Work Type has nested team members. You can always add team members via \"Add role\" button in Summary and Timeline tables.",
        "content_for_tm": "This field is locked when Project Timeline is visible. You can always add team members via \"Add role\" button in Summary and Timeline tables."
      },
      "profitability_fixed_alert": {
        "title": "Fixed cost",
        "content": "You have set this element type as the fixed cost. To change its type, go to the estimate editor and put in an estimate in man-hours or man-days."
      },
      "workType_permits": "Assign estimator",
      "change_workType": "Change work type",
      "remove_workType": "Remove work type",
      "remove_resource": "Remove team member",
      "status_change": "Change estimation status",
      "status_pending": "Estimation pending",
      "status_done": "Estimation done",
      "hide_workType": "Hide work type",
      "custom_workType": "Add new \"{{value}}\" work type",
      "no_work_types": "No work types found",
      "add_section": "Add Section",
      "add_component": "Create new component",
      "xls_worksheet": "Summary & Breakdown",
      "task_list_type": {
        "library": "Library",
        "projects": "Projects"
      },
      "versioning": {
        "name": "Version name",
        "change": "Change name",
        "copy_comments": "\"{{name}}\" includes comments. Do you want to copy the comments to the new version?"
      },
      "timeline_table": {
        "role": "Role",
        "billing": "Billing",
        "workType_settings": "Work type settings",
        "work_start": "Start work on",
        "team_together": "Team finishes together",
        "add_period": "Add new timeline month",
        "remove_period": "Remove month",
        "show_week": "Show weekly hours",
        "hide_week": "Show monthly hours",
        "percentage": {
          "summary": "Calculated as a {{percent}}% of {{workTypes}} - based on your percentage calculation settings in estimate summary",
          "breakdown": "Calculated as a weighted average of {{workTypes}} - based on your percentage calculation settings from the estimate breakdown."
        },
        "custom_amount": "Custom"
      },
      "breakdown_table": {
        "search": {
          "open": "Search elements",
          "close": "Close search",
          "placeholder": "Add search phrase"
        },
        "label_filter": "Filter by labels",
        "not_found": "No estimate elements found",
        "columns": {
          "numeration": "Numeration",
          "title": "Title",
          "labels": "Label",
          "description": "Description",
          "estimates": "Estimate",
          "price": "Price"
        },
        "pin_block": "This column cannot be pinned.",
        "unpin_block": "This column cannot be unpinned.",
        "no_sections": "Project has no sections",
        "alert_titles": {
          "remove": "This will delete the Description 2 column from all sections. Do you want to proceed?",
          "add": "Do you want to add this column to all sections or just this section?",
          "this_section": "Just this section",
          "all_sections": "Add to all sections"
        },
        "add_description_column": "Add text column"
      },
      "summary_table": {
        "workload": "Workload",
        "work_add": "Add work type",
        "work_resource_add": "Add role",
        "time": "Duration",
        "time_weeks": "Duration (weeks)",
        "time_months": "Duration (months)",
        "team": "Team",
        "team_members": "Team members",
        "rate": "Rate",
        "hourly_rate": "Hourly Rate",
        "hours": "Hours / Days",
        "rate_hours": "Hourly rate",
        "cost_hours": "Hourly cost",
        "rate_days": "Daily rate",
        "cost_days": "Daily cost",
        "cost": "Price",
        "cost_pa": "Cost",
        "cost_currency": "Price ({{currency}})",
        "revenue": "Revenue",
        "profit": "Profit",
        "profitability": "Profitability",
        "totals": {
          "title": "Totals",
          "cost": "Total price",
          "company_cost": "Total cost",
          "revenue": "Total revenue",
          "profit": "Total profit",
          "profitability": "Total profitability",
          "time": "Total duration",
          "hours": "Total hours",
          "days": "Total days"
        },
        "currency_exchange": {
          "title": "{{currency}} / {{companyCurrency}} exchange rate:",
          "tooltip": "Auto option updates the currency exchange rate every day. Custom exchange rate saves your own exchange rate."
        },
        "hours_placeholder": "Add hours",
        "price_placeholder": "Add rate",
        "hide_system": "Hide in breakdown table",
        "show_system": "Show in breakdown table",
        "fixed_costs": "Fixed costs",
        "materials": "Materials"
      },
      "remove_rows": {
        "0": "Remove section",
        "1": "Remove module",
        "2": "Remove feature",
        "3": "Remove task"
      },
      "dialogs": {
        "save": {
          "title": "Save project as",
          "template": "Template name",
          "location": "Choose folder"
        },
        "proposal": {
          "breakdown": "breakdown",
          "prices": "breakdown + prices"
        },
        "share": {
          "title": "Share with client",
          "email": "Email address",
          "link": "Get link",
          "link_click": "Click to copy link",
          "accept": "Share proposal",
          "sent": "Success! Your Proposal was sent.",
          "no_privileges": "Only a project editor can share the proposal!",
          "settings": {
            "turn_off": "Client can turn off / on proposal elements",
            "show_off": "Show switched-off elements in the proposal",
            "show_bottom_bar": "Show bottom bar",
            "show_exports": "Client can download the quote",
            "include_version": "Include version in the URL",
            "preset": "Select preset"
          }
        },
        "export": {
          "title": "Export project estimation",
          "file_format": "Choose file format for export"
        },
        "rates": {
          "title": "Change rates"
        },
        "features": {
          "module": "Featured from selected module",
          "type": "Featured from selected app type",
          "all": "All features from all the apps",
          "headers": {
            "parent": "Recommended for \"{{item}}\"",
            "recommended": "Recommended",
            "other": "Others",
            "library": "Elements from ",
            "library_link": "library"
          },
          "search": "Type at least 3 characters",
          "new_name_0": "Section title",
          "new_name_1": "Module title",
          "new_name_2": "Feature title",
          "new_name_3": "Task title",
          "new_name_library": "Enter element name",
          "not_found": "No elements found",
          "new_desc": "New feature's description (optional)",
          "add_new": "No features found. To add new one, type it's title in the field above and confirm.",
          "duplicate_error": "Feature with such name already exists"
        },
        "work_types": {
          "focused": "Search work type"
        },
        "resources": {
          "focused": "Search team member",
          "placeholder": "Team member"
        },
        "display": {
          "reset": "Reset display settings",
          "add_to_section": "Do you wish to add {{workTypeName}} to the {{sectionName}} section?",
          "disabled_tooltip": {
            "part1": "You can’t display {{workTypeName}} in this section because it has not been added to this section.",
            "part2": "To add {{workTypeName}} to this section, click here."
          }
        },
        "roundings": {
          "title": "Roundings",
          "subtitle": "Enable roundings",
          "reset": "Reset rounding settings",
          "different_section_rounding_alert": {
            "title": "Different rounding settings",
            "content1": "{{name}} has different rounding settings set for different sections. Setting a project-wise rounding here will overwrite these settings.",
            "content2": "Do you wish to continue?",
            "accept": "Yes, apply rounding"
          }
        },
        "automation": {
          "reset": "Reset calculation settings",
          "title_old": "Estimate value",
          "title": "Percentage calculations",
          "enable": "Enable percentage calculations",
          "disable": "Disable percentage calculations",
          "fixed": "Fixed amount",
          "empty": "No available work types",
          "empty_sections": "No available sections",
          "qa_percentage": "Estimate {{work}} as percentage of the chosen work types",
          "generate": "Generate estimation",
          "used_in_sections": "You can't select {{targetWTName}} in the formula because it would trigger circular dependency, as {{wTName}} is used to calculate {{targetWTName}} in: ",
          "calculated_from": "Calculated as % of {{list}}",
          "different_section_autmation": "{{name}} has different percentage calculation settings set for different sections. Setting a project-wise percentage calculation here will overwrite these settings.",
          "different_section_autmation_alert": {
            "title": "Different percentage calculation settings",
            "content1": "{{name}} has different percentage calculation settings set for different sections. Setting a project-wise percentage calculation here will overwrite these settings.",
            "content2": "Do you wish to continue?",
            "accept": "Yes, apply"
          }
        },
        "buffers": {
          "title": {
            "project": "Project buffers",
            "item": "Buffers"
          },
          "create": {
            "item": "Add item buffer",
            "project": "Add project buffer"
          },
          "subtitle": {
            "item": "Item buffers",
            "project": "Project buffers"
          },
          "info": {
            "item": "Item buffer will only be applied to this its element and elements below it.",
            "project": "Project buffers are applied to the entire project."
          },
          "item_tooltip": "This buffer is applied to the {{elementType}} and its children.",
          "turn_off_all": {
            "on": "Turn on previously used buffers",
            "off": "Turn off all Buffers"
          },
          "add": "Add buffer",
          "name_placeholder": "Enter buffer's name",
          "none": "No added buffers",
          "name_new": "New buffer",
          "name_full": "{{levelName}} buffer",
          "alert": {
            "project": "Scroll to Summary to edit Project Buffers.",
            "item": "Scroll to parent {{levelName}} to edit this Buffer."
          },
          "remove": "Are you sure you want to delete this Buffer?",
          "display_mode": "Buffers display mode"
        },
        "price_modifiers": {
          "create": "Add discount or overhead",
          "discount_name_placeholder": "Enter discount's name",
          "overhead_name_placeholder": "Enter overhead's name",
          "new": {
            "discount": "New discount",
            "overhead": "New overhead"
          },
          "add": {
            "discount": "Add discount",
            "overhead": "Add overhead"
          },
          "edit": {
            "discount": "Edit discount",
            "overhead": "Edit overhead"
          },
          "remove": {
            "discount": "Remove discount",
            "overhead": "Remove overhead"
          },
          "remove_confirm": {
            "discount": "Are you sure you want to delete this discount?",
            "overhead": "Are you sure you want to delete this overhead?"
          }
        },
        "work_type_settings": {
          "title": "Work type settings",
          "display":{
            "title": "Display settings",
            "subtitle": "Display the work type \"{{name}}\" in:"
          },
          "rounding": "Roundings",
          "automation": "Percentage calculations",
          "decimal": {
            "title": "Decimal places",
            "toggle_label": "Hide decimal places",
            "decimals": "Decimal places displayed",
            "sample_input": "Sample input",
            "sample_output": "Sample output"
          }
        },
        "filled_module_alert": {
          "title": "You already filled parent's module values. Do you want to move them to this one or clear them?",
          "confirm": "Move them",
          "cancel": "Clear them"
        },
        "remove_alert": {
          "title_level0": "Remove this section & all its contents?",
          "title_level1": "Remove this module and all features & tasks it includes?",
          "title_level2": "Remove this feature and all tasks it includes?",
          "title_level3": "Remove this task?",
          "intermediate": "Remove, but keep it's modules"
        },
        "move_alert": {
          "title_level1": "This section already contains this module",
          "title_level2": "This module already contains this feature",
          "title_level3": "This feature already contains this task",
          "subtitle": "Do you wish to merge them, or cancel this operation?",
          "confirm": "Merge"
        },
        "clear_alert": {
          "title_level_0": "Do you want to reset this section and all its modules', features' & tasks' values?",
          "title_level_1": "Do you want to reset this module and all its features' & tasks' values?",
          "title_level_2": "Do you want to reset this feature and all its tasks' values?",
          "title_level_3": "Do you want to reset this task's values?",
          "confirm": "Yes, reset"
        },
        "category": {
          "title": "Category",
          "desc": "Choose application category, that best matches your project",
          "save": "Set category"
        },
        "recovery": {
          "title": "Recover project data",
          "desc": "Your local project version is newer than remote one. Do you wish to restore it, or proceed with remote version?",
          "accept": "Restore",
          "cancel": "Proceed"
        },
        "currency": {
          "title": "Currency settings",
          "filter": "Filter currencies",
          "not_found": "No currencies found"
        },
        "sales_currency_alert": {
          "title": "Do you wish to convert the existing rates to {{selectedCurrency}}?",
          "accept": "Yes. convert to {{selectedCurrency}}",
          "cancel": "No, don't convert"
        },
        "summary_add_currency_alert": {
          "title": "Currency difference",
          "subtitle": "The sales rate currency in this project ({{estimateCurrency}}) is different than the sales rate currency set for this work type in your workspace's rate card ({{systemCurrency}}).",
          "button_group": "Do you want to:",
          "change": "Change project sales currency to {{systemCurrency}}",
          "convert": "Convert the hourly rate from the rate card ({{systemCurrency}}) to {{estimateCurrency}}",
          "load": "Load without conversion",
          "accept": "Apply selected option"
        },
        "policy": {
          "text": "Privacy and Cookies Notice.<br/><br/>When you access a quoting proposal generated by one of Apropo's users, we record your activity and share it with said user. This is done pursuant to our legitimate interests, as part of Apropo's service. Learn more about how we process personal data in our <a href=\"https://app.apropo.io/policy\" target=\"_blank\">Privacy & Cookies Policy</a>.<br/><br/>Additionally, we use cookies and other similar technologies to keep Apropo secure and reliable, personalize and improve our services and for marketing purposes. To do this we collect information about you and your behavior on Apropo. We share such information with third parties, including advertising and analytics partners. You can accept or refuse our cookies or learn more by clicking on the buttons below or by visiting our <a href=\"https://app.apropo.io/policy\" target=\"_blank\">Privacy & Cookies Policy</a>.",
          "accept": "I agree"
        },
        "summary_settings": {
          "title": "Summary settings",
          "columns": "Column visibility",
          "columns_tooltip": "Choose which columns should be used in your proposal's summary.",
          "totals": "Totals visibility",
          "totals_tooltip": "Choose which totals should be used in your proposal's summary."
        },
        "timeline_settings": {
          "title": "Timeline settings",
          "mta": "Monthly time allocation",
          "wta": "Weekly time allocation",
          "mta_change": "Change monthly time allocation",
          "wta_change": "Change weekly time allocation",
          "mta_tooltip": "Monthly Time Allocation - amount of work hours per month",
          "wta_tooltip": "Weekly Time Allocation - amount of work hours per month",
          "mta_restore": "Restore default MTA",
          "wta_restore": "Restore default WTA"
        },
        "project_settings": {
          "title": "Project settings",
          "tables": "Table visibility",
          "profitability": {
            "on": "Show profitability analysis",
            "off": "Hide profitability analysis"
          },
          "tables_tooltip": "Choose which tables should be used in your project. You can also reorder them by dragging up or down."
        },
        "price_settings": {
          "title": "Price settings",
          "rounding_price": "Price rounding",
          "round_price": "Round prices",
          "format": "Price format",
          "no_price_rounding": "No prices rounding (fixed decimals)",
          "tooltips": {
            "round_price": "Round prices & hourly rates to full numbers in breakdown and summary",
            "round_price_day": "Round prices & daily rates to full numbers in breakdown and summary"
          },
          "formats": {
            "european": "European",
            "european_eg": "(e.g. $10 000.00)",
            "american": "American",
            "american_eg": "(e.g. $10,000.00)"
          },
          "pin": {
            "label": "Pin price column",
            "on": "Pin price column",
            "off": "Unpin price column",
            "tooltip": "Pinned price column will not move when scrolling the quote horizontally"
          },
          "hidden_work_types": {
            "label": "Include hidden work types in line item price",
            "on": "Include hidden work types",
            "off": "Exclude hidden work types"
          }
        },
        "settings": {
          "title": "Breakdown settings",
          "level": "Level of detail",
          "sections": "Section format",
          "section_formats": {
            "1": "Expandable, with subtotal (default)",
            "2": "Non-expandable, with subtotal",
            "3": "Non-expandable, no subtotal"
          },
          "values": "Show estimates for",
          "rounding_hours": "Hide decimal places",
          "rounding_days": "Days rounding",
          "round_type": "Rounding type",
          "round_apply": "Apply rounding to",
          "round_soft": "Soft",
          "round_hard": "Hard",
          "round_decimal": "Decimal places",
          "risk_buffer": "Risk buffer",
          "different_alert": "Value updated",
          "risk": "Risk: {{value}}%",
          "round_hours": "Round hours",
          "no_hours_rounding": "No hours rounding (fixed decimals)",
          "tooltips": {
            "round_hour": "Round all hours in breakdown and summary. You choose the type of rounding.",
            "round_day": "Round all days in breakdown and summary. You choose the type of rounding.",
            "risk_buffer": "Apply additional % of hours to each work type",
            "round_type_1": "Soft rounding - rounds the values only visually, without changing the actual values. Has the same effect as “Reduce / Increase decimal points” feature in Excel.",
            "round_type_2": "Hard rounding - changes the values to full numbers (integers). Has the same effect as Round, Round Up and RoundDown functions in Excel."
          },
          "description_mode": "Element description format",
          "parent_estimates": "Show estimates for expanded components",
          "children_counter": "Show children items counter"
        },
        "timeline_visibility": "Project timeline elements",
        "auto_estimation": {
          "title": "Confirmation",
          "desc": "Auto estimation will alter all values in breakdown table. This operation is irreversible."
        }
      },
      "preset": {
        "new": "New preset",
        "create": "Create preset",
        "create_new": "Create new preset",
        "name": "Enter new preset's name",
        "save_as": "Copy preset",
        "preview": "View as client",
        "preset_picker": "Preset",
        "placeholder_preset": "Select preset",
        "default": "Default preset",
        "apropo": "Apropo",
        "no_preset": "No preset",
        "font_picker": "Font",
        "placeholder_font": "Select font",
        "custom_font": {
          "import": "Import custom font",
          "title": "Upload custom font",
          "text": "Drag font file here or ",
          "text_active": "Drop font file here",
          "upload": "Upload font file",
          "name": "Name of your font",
          "success": "Your font has been successfully added.",
          "success2": "You can now find it on the fonts list."
        },
        "drop_page": "Drop selected page here",
        "alert": {
          "title": "You have unsaved changes to the preset",
          "accept": "Save and close"
        },
        "remove": "Remove preset",
        "alert_remove": "Are you sure you want to delete this preset?",
        "edit": {
          "delete": "Delete",
          "new_logo": "Upload new logo"
        },
        "tags": {
          "preset-title": "Project title",
          "preset-logo": "Logo",
          "preset-bar": "Main color accent",
          "preset-totalHoursTitle": "Total hours/day label",
          "preset-totalTimeTitle": "Total duration label",
          "preset-totalCostTitle": "Total price label",
          "preset-totalCost": "Price total",
          "preset-totalHours": "Hours/days total",
          "preset-totalTime": "Duration total",
          "preset-text": "Value",
          "preset-titleText": "Name",
          "preset-titleTextSection": "Section name",
          "preset-summaryText": "Summary value",
          "preset-timelineText": "Timeline value",
          "preset-summaryTitleText": "Work type or team member name",
          "preset-timelineTitleText": "Work type or team member name",
          "preset-tableFooter": "Section summary",
          "preset-summaryHeader": "Summary table header",
          "preset-timelineHeader": "Timeline table header",
          "preset-timelineSubHeader": "Timeline table section header",
          "preset-breakdownHeader": "Breakdown table header",

          "preset-descriptionHeader": "Description Title",
          "preset-tableBreakdownHeader": "Column header",
          "preset-tableSummaryHeader": "Column header",
          "preset-tableTimelineHeader": "Column header",
          "preset-textDescriptionHeader": "Column header",
          "preset-tableTimelineBilling": "Billing scale",

          "preset-textDescriptionContent": "Description",

          "preset-price": "Price",
          "preset-moreDescSection": "\"See more\" button",
          "preset-moreDesc": "\"See more\" button",
          "preset-section": "Section",
          "preset-sectionRow": "Section row",
          "preset-section-0": "Section",
          "preset-sectionDesc": "Section description",
          "preset-active-1": "Expanded module",
          "preset-active-2": "Expanded feature",
          "preset-row": "Breakdown table row",
          "preset-rowDesc": "Element description row",
          "preset-activeSummary": "Expanded summary row",
          "preset-activeTimeline": "Expanded timeline row",
          "preset-rowSummary": "Summary table row",
          "preset-rowTimeline": "Timeline table row",
          "preset-paper": "Title & Summary",
          "preset-paperTimeline": "Timeline",
          "preset-paperTextDescription": "Description",
          "preset-page": "Page",
          "preset-export": "Export button",
          "preset-version": "Version button",
          "preset-version-active": "Version button",
          "preset-timelineMode": "Timeline min-max button",
          "preset-timelineModeActive": "Active timeline min-max button",
          "preset-tableBreakdownExpandButton": "Expand button",
          "preset-tableSummaryExpandButton": "Expand button",
          "preset-tableTimelineExpandButton": "Expand button",
          "preset-textDescriptionExpandButton": "Expand button",
          "preset-commentsSidebarButton": "Comments sidebar button",
          "preset-showPriceForIcon": "Show price button icon",
          "preset-showPriceFor": "Show price button",
          "preset-textSearchButton": "Text search button",
          "preset-labelFilterButton": "Label filter button",
          "preset-scrollButton": "Scroll button",
          "preset-bottomBarOpenButton": "Bottom bar's open button",
          "preset-bottomBarButton": "Bottom bar's close button",
          "preset-breakdownExpandButton": "Children items counter"
        },
        "edit_tags": {
          "preset-title": "Edit project title",
          "preset-logo": "Edit logo",
          "preset-bar": "Edit main color accent",
          "preset-totalHoursTitle": "Edit total hours/day label",
          "preset-totalTimeTitle": "Edit total duration label",
          "preset-totalCostTitle": "Edit total price label",
          "preset-totalCost": "Edit price total",
          "preset-totalHours": "Edit hours/days total",
          "preset-totalTime": "Edit duration total",
          "preset-text": "Edit value",
          "preset-titleText": "Edit element accent",
          "preset-titleTextSection": "Edit section accent",
          "preset-summaryText": "Edit summary value",
          "preset-timelineText": "Edit timeline value",
          "preset-summaryTitleText": "Edit work type or team member name",
          "preset-timelineTitleText": "Edit work type or team member name",
          "preset-tableFooter": "Edit section summary",
          "preset-summaryHeader": "Edit summary table header",
          "preset-timelineHeader": "Edit timeline table header",
          "preset-timelineSubHeader": "Edit timeline table section header",
          "preset-breakdownHeader": "Edit breakdown table header",

          "preset-descriptionHeader": "Edit description Title",
          "preset-tableBreakdownHeader": "Edit column header",
          "preset-tableSummaryHeader": "Edit column header",
          "preset-tableTimelineHeader": "Edit column header",
          "preset-textDescriptionHeader": "Edit column header",
          "preset-tableTimelineBilling": "Edit billing scale",

          "preset-textDescriptionContent": "Edit description",

          "preset-price": "Price",
          "preset-moreDescSection": "Edit \"See more\" button",
          "preset-moreDesc": "Edit \"See more\" button",
          "preset-section": "Edit section accent",
          "preset-sectionRow": "Edit section row",
          "preset-section-0": "Edit section accent",
          "preset-sectionDesc": "Edit section description",
          "preset-active-1": "Edit expanded module row",
          "preset-active-2": "Edit expanded feature row",
          "preset-row": "Edit breakdown table row",
          "preset-rowDesc": "Edit element description row",
          "preset-rowSummary": "Edit summary table row",
          "preset-rowTimeline": "Edit timeline table row",
          "preset-activeSummary": "Edit expanded summary row",
          "preset-activeTimeline": "Edit expanded timeline row",
          "preset-paper": "Edit title background",
          "preset-paperTimeline": "Edit timeline background",
          "preset-paperTextDescription": "Edit description background",
          "preset-page": "Edit background color",
          "preset-export": "Edit export button",
          "preset-version": "Edit version button",
          "preset-version-active": "Edit version button",
          "preset-timelineMode": "Edit timeline min-max button",
          "preset-timelineModeActive": "Edit active timeline min-max button",
          "preset-taskDesc": "Edit description button",
          "preset-tableBreakdownExpandButton": "Edit expand button",
          "preset-tableSummaryExpandButton": "Edit expand button",
          "preset-tableTimelineExpandButton": "Edit expand button",
          "preset-textDescriptionExpandButton": "Edit expand button",
          "preset-commentsSidebarButton": "Edit comments sidebar button",
          "preset-showPriceForIcon": "Edit show price button icon",
          "preset-showPriceFor": "Edit show price button",
          "preset-textSearchButton": "Edit text search button",
          "preset-labelFilterButton": "Edit label filter button",
          "preset-scrollButton": "Edit scroll button",
          "preset-bottomBarOpenButton": "Edit Bottom bar's open button",
          "preset-bottomBarButton": "Edit Bottom bar's close button",
          "preset-breakdownExpandButton": "Edit children items counter"
        }
      },
      "steps": {
        "1": "Estimate the project",
        "2": "Apply your branding",
        "3": "Attach presentation"
      },
      "comments": {
        "name": "Comments",
        "tooltip": "Add comment",
        "tooltip_readonly": "View comments",
        "placeholder": "Comment",
        "placeholder_full": "Comment or add others with @",
        "remove_alert": {
          "thread": "Do you really want to remove this chat thread?",
          "message": "Do you really want to remove this message?"
        },
        "read": "All comments",
        "unread": "Unread comments",
        "internal": "Internal",
        "internal_full": "Internal comments",
        "external": "External",
        "external_info": "External comments are visible to the client. Internal comments are not visible to the client.",
        "no_external": "No external comments",
        "no_internal": "No internal comments",
        "more_replies": "+ {{amount}} more replies",
        "link": {
          "copy": "Copy link to comment",
          "copied": "Link copied!"
        },
        "jump_source": "Jump to component",
        "no_comments": {
          "all": "No comments have been added on this project",
          "version": "No comments have been added on \"{{name}}\""
        }
      },
      "visibility": {
        "title": "Visibility management",
        "title_back": "Estimate editor",
        "breakdown_settings": "Breakdown visibility settings",
        "show": "Show {{thing}} on proposals",
        "hide": "Hide {{thing}} on proposals",
        "show_this": "Show this {{thing}} on proposals",
        "hide_this": "Hide this {{thing}} on proposals",
        "version": "version",
        "summary": "summary",
        "timeline": "timeline",
        "breakdown": "breakdown"
      }
    },
    "pdf_viewer": {
      "save": "Save file",
      "export_full": "Download PDF",
      "summary_table": "Proposal",
      "documents": "Documents",
      "import": {
        "button": "Import PDF",
        "document": "Upload PDF",
        "replace": "Replace PDF",
        "remove": "Remove document",
        "append": "Append document"
      },
      "tooltips": {
        "hide": "Hide list",
        "show": "Show PDF pages list"
      },
      "scale": {
        "page_fit": "Fit to page",
        "page_width": "Fit to width"
      }
    }
  },
  "integrations": {
    "calendly": {
      "label": "Calendly link",
      "desc": "By providing your unique Calendly link, you'll enable your clients to schedule meetings right from within shared proposal!",
      "error": "Link should look like \"https://calendly.com/john-doe\""
    }
  },
  "routes": {
    "login": "Sign in",
    "login_full": "Sign in to Apropo",
    "register": "Register",
    "create_account": "Create an account",
    "activate": "Confirm registration",
    "home": "Home",
    "active": "Active projects",
    "archived": "Archived projects",
    "notifications": "Notifications",
    "notifications_new": "Notifications ({{new}} new)",
    "contact": "Contact Us",
    "subscription": "Subscription & Team",
    "pricing": "Pricing",
    "team": "My team",
    "help": "Help",
    "settings": "Settings",
    "boards": "Boards",
    "terms": "Terms and Conditions",
    "policy": "Privacy policy",
    "sessions": "Customers' sessions",
    "recordings": "View recordings",
    "session_player": "Session player",
    "jira": "Jira integration",
    "templates": "Templates",
    "library": "Library",
    "editor_project": "Project Editor",
    "editor_template": "Template Editor",
    "estimate": "Estimate"
  },
  "dialogs": {
    "inviteContractor":{
      "button": "Invite contractor",
      "title": "Invite contractor to Apropo",
      "description": "Enter the email address of your contractor to invite them to Apropo. They will be able to view and comment on your proposals, but won't have access to your company board or any other projects.",
      "pick_from_list": "Pick from existing contractors",
      "success": "Invitation sent! Your contractor will receive an email with instructions to join Apropo and access your proposals.",
      "fail": "Invitation failed. Please check the email address and try again."
    },
    "projectNotFound": {
      "title": "Project not available",
      "message": "This project is no longer available or you don't have access to it. The project may have been removed or your access may have been revoked. Please contact the project owner for more information."
    },
    "projectAccess": {
      "title": "Access denied",
      "message": "You don't have access to project \"{{projectName}}\".",
      "thisProject": "this project",
      "contactOwner": "Contact the project owner: {{email}}",
      "requestButton": "Request access",
      "requestSent": "Access request sent successfully.",
      "requestFailed": "Failed to send access request. Please try again."
    }
  }
}
